import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Service } from '../types/service';
export function ServiceCard({
  service
}: {
  service: Service;
}) {
  return <Link to={`/services/${service.slug}`} className="group flex h-full flex-col overflow-hidden rounded-sm border border-steel-200 bg-white shadow-card transition hover:-translate-y-0.5 hover:border-safety" data-id="element-235" data-mp="2qj6x95mfen5x">
      {service.image ? <div className="aspect-[16/10] overflow-hidden bg-steel-100" data-id="element-236" data-mp="30glayxgysxuj">
          <img src={service.image} alt={service.imageAlt ?? ''} loading="lazy" className="h-full w-full object-cover object-center transition duration-300 group-hover:scale-105" data-id="element-237" data-mp="34ig9xvbfaz55" />
        </div> : <div className="hatch h-2 w-full" aria-hidden="true" data-id="element-238" data-mp="3j9oye13laegp" />}
      <div className="flex flex-1 flex-col p-5" data-id="element-239" data-mp="3o807uapz2mye">
        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-safety" data-id="element-240" data-mp="3o8s5rs71kwru">
          {service.category}
        </p>
        <h3 className="mt-1.5 font-display text-xl font-semibold uppercase tracking-tight text-ink" data-id="element-241" data-mp="247pf3vcesfkj">
          {service.name}
        </h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-steel-500" data-id="element-242" data-mp="1ub2vf9vtjuk3">
          {service.summary}
        </p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold uppercase tracking-wide text-ink group-hover:text-safety" data-id="element-243" data-mp="1qaso9twaiy3n">
          Details
          <ArrowRightIcon className="h-4 w-4 transition group-hover:translate-x-0.5" aria-hidden="true" data-id="element-244" data-mp="2n24j5zdkuyf8" />
        </span>
      </div>
    </Link>;
}